import { combineReducers } from 'redux';
import clubsReducer from './Categories/clubsReducer';

const categoriesReducer = combineReducers({
  clubs: clubsReducer,
});

export default categoriesReducer;
